const d = (e) => {
  const t = new Intl.DateTimeFormat("en-AU", { weekday: "short" }).format(e), a = new Intl.DateTimeFormat("en-AU", { weekday: "long" }).format(e), o = new Intl.DateTimeFormat("en-AU", { month: "short", day: "numeric" }).format(e), r = new Intl.DateTimeFormat("en-AU", { month: "short" }).format(e), i = new Intl.DateTimeFormat("en-AU", { month: "long" }).format(e), l = +new Intl.DateTimeFormat("en-AU", { month: "numeric" }).format(e), c = new Intl.DateTimeFormat("en-AU", { hour: "numeric", minute: "numeric", hour12: !0 }).format(e), m = new Intl.DateTimeFormat("en-AU", { hour: "2-digit", minute: "2-digit", hour12: !1 }).format(e), D = new Intl.DateTimeFormat("en-AU", { day: "numeric" }).format(e), n = e.getDate();
  return { dayOfWeek: t, longDayOfWeek: a, monthThenDate: o, shortMonth: r, time: c, time24: m, datePart: D, dateNumber: n, monthNumber: l, longMonth: i };
}, I = (e, t) => {
  const a = new Date(e);
  return new Date(a.setDate(a.getDate() + t));
}, T = (e) => {
  const t = /* @__PURE__ */ new Date();
  return e.toDateString() === t.toDateString();
}, F = (e) => {
  const t = /* @__PURE__ */ new Date();
  return t.setDate(t.getDate() - 1), e.toDateString() === t.toDateString();
}, Y = (e) => {
  const t = /* @__PURE__ */ new Date();
  return t.setDate(t.getDate() + 1), e.toDateString() === t.toDateString();
}, P = (e, t = {}) => {
  const a = typeof e == "string" ? new Date(e) : e, o = d(a);
  let {
    showTime: r = !0,
    showDate: i = !0,
    showDay: l = !1,
    hour24: c = !1
  } = t, m = "", D = "";
  r = r && (a.getHours() !== 0 || a.getMinutes() !== 0 || a.getSeconds() !== 0);
  const n = c ? o.time24 : o.time, s = r ? i ? " " + n : n : "";
  return i && (T(a) ? m = "Today" : F(a) ? m = "Yesterday" : Y(a) ? m = "Tomorrow" : m = (l ? o.longDayOfWeek + " " : "") + o.monthThenDate), i && a.getFullYear() !== (/* @__PURE__ */ new Date()).getFullYear() && (D = " " + a.getFullYear()), `${m}${D}${s}`;
}, A = (e, t, a = {}) => {
  const o = typeof e == "string" ? new Date(e) : e, r = typeof t == "string" ? new Date(t) : t, i = d(o), l = d(r), {
    showTime: c = !0,
    showDate: m = !0,
    showDay: D = !1
  } = a;
  let n = 1;
  m && o.getFullYear() !== (/* @__PURE__ */ new Date()).getFullYear() && (n = 2), r.getFullYear() !== (/* @__PURE__ */ new Date()).getFullYear() && (o.getFullYear() == r.getFullYear() ? n = 8 : n = n | 4);
  let s = 1;
  m && (i.monthNumber == l.monthNumber && (n & 8 || n & 1) ? s = 8 : s = 6);
  let f = 1;
  m && (s == 8 && i.dateNumber == l.dateNumber ? f = 8 : (f = 6, s = 6));
  let y = "";
  (s & 2 || s & 8) && (T(o) ? y = "Today" : F(o) ? y = "Yesterday" : Y(o) ? y = "Tomorrow" : y = (D ? i.longDayOfWeek + " " : "") + i.monthThenDate);
  let g = "";
  n & 2 && (g = ` ${o.getFullYear()}`), n & 8 && f & 8 && (g = ` ${o.getFullYear()}`);
  const p = c ? ` ${i.time}` : "";
  let u = "";
  if (s & 4 || s & 8) {
    if (T(r))
      u = "Today";
    else if (F(r))
      u = "Yesterday";
    else if (Y(r))
      u = "Tomorrow";
    else {
      const w = D ? l.longDayOfWeek + " " : "";
      s & 4 ? u = w + l.monthThenDate : u = w + l.datePart;
    }
    f & 8 && (u = "");
  }
  let h = "";
  (n & 4 || n & 8) && (h = ` ${r.getFullYear()}`), n & 8 && f & 8 && (h = "");
  const $ = c ? ` ${l.time}` : "";
  return `${y}${g}${p} - ${u}${h}${$}`;
}, U = (e) => {
  const t = e.split(":");
  return t.length !== 2 ? 0 : parseInt(t[0], 10) * 60 + parseInt(t[1], 10);
};
export {
  I as addDaysToDate,
  d as formatDate,
  T as isToday,
  U as parseTimeToMinutes,
  P as prettyDate,
  A as prettyDateRange
};
//# sourceMappingURL=dates.js.map
